// // Login.jsx
// import Wrapper from '../assets/wrappers/RegisterAndLoginPage';
// import { FormRow, Logo, SubmitBtn } from '../components';
// import { toast } from 'react-toastify';
// import React, { useEffect } from 'react';
// import { Link, Form, redirect, useNavigate, useLocation } from 'react-router-dom';
// import { customFetch } from '../utils/custom-fetch.js';

// // 🧠 Loader — נשאר ריק או בסיסי
// export const loader = async () => {
//   // return null;
//   const { data } = await customFetch.get('/users/current-user');
//   console.log('Current user:', data);
//   return data; // { user }
  
// };


// export const action = async ({ request }) => {
//   const formData = await request.formData();
//   const data = Object.fromEntries(formData);

//   const url = new URL(request.url);
//   const redirectPath = url.searchParams.get('redirect') || 'dashboard';

//   const searchParams  = new URLSearchParams(url.searchParams);
//   searchParams.delete('redirect');
//   const queryString   = searchParams.toString();

//   try {
//     await customFetch.post('/auth/login', data);
//     toast.success('ההתחברות בוצעה בהצלחה');

//     const redirectUrl = `/${redirectPath}${queryString ? `?${queryString}` : ''}`;
//     return redirect(redirectUrl);
//   } catch (error) {
//     toast.error(error?.response?.data?.msg || 'שגיאה בהתחברות');
//     return null;
//   }
// };

// const Login = () => {
//   const location = useLocation();
//   const redirectPath = new URLSearchParams(location.search).get("redirect") || "dashboard";
//   const screenId = new URLSearchParams(location.search).get("screenId");
//   const sessionToken = new URLSearchParams(location.search).get("sessionToken");

//   return (
//     <Wrapper>
//       <Form method='post' className='form'>
//         <Logo />
//         <h4>כניסה</h4>

//         <FormRow
//           type='email'
//           name='email'
//           defaultValue=''
//           labelText='כתובת דואר אלקטרוני'
//         />
//         <FormRow
//           type='password'
//           name='password'
//           defaultValue=''
//           labelText='סיסמה'
//         />

//         <SubmitBtn buttonText='כניסה' />
//         <p>
//           עדין לא נרשמת ?
//           <Link to='/register' className='member-btn'>
//             הרשמה
//           </Link>
//         </p>
//       </Form>
//     </Wrapper>
//   );
// };

// export default Login;


// src/pages/Login.jsx
import React from 'react';
import { Form, Link, redirect, useLocation } from 'react-router-dom';
import Wrapper from '../assets/wrappers/RegisterAndLoginPage';
import { FormRow, Logo, SubmitBtn } from '../components';
import { toast } from 'react-toastify';
import { customFetch } from '../utils/custom-fetch';

// 🧠 Loader – אם כבר מחובר, ננווט חזרה
export const loader = async () => {
  try {
    const { data } = await customFetch.get('/users/current-user');
    // אם לא מאומת – נייד ל־verify-email
    if (!data.user?.isVerified) {
      return redirect(`/verify-email/${data.user._id}`);
    }
    // מחובר ומאומת – נייד ל־dashboard
    return redirect('/dashboard');
  } catch {
    // אין טוקן תקף או קריאה נכשלה – נשארים בעמוד Login
    return null;
  }
};

export const action = async ({ request }) => {
  const formData = await request.formData();
  const payload  = Object.fromEntries(formData);

  const url = new URL(request.url);
  const redirectPath = url.searchParams.get('redirect') || 'dashboard';
  url.searchParams.delete('redirect');
  const qs = url.searchParams.toString();

  try {
    await customFetch.post('/auth/login', payload);
    toast.success('ההתחברות בוצעה בהצלחה');
    return redirect(`/${redirectPath}${qs ? `?${qs}` : ''}`);
  } catch (error) {
    toast.error(error?.response?.data?.msg || 'שגיאה בהתחברות');
    return null;
  }
};

const Login = () => {
  const location = useLocation();
  const redirectPath = new URLSearchParams(location.search).get("redirect") || "dashboard";

  return (
    <Wrapper>
      <Form method='post' className='form'>
        <Logo />
        <h4>כניסה</h4>

        <FormRow
          type='email'
          name='email'
          defaultValue=''
          labelText='כתובת דואר אלקטרוני'
        />
        <FormRow
          type='password'
          name='password'
          defaultValue=''
          labelText='סיסמה'
        />

        <SubmitBtn buttonText='כניסה' />
        <p>
          <Link to='/forgot-password' className='member-btn'>
            שכחתי סיסמה
          </Link>
        </p>
        <p>
          עוד לא רשום?
          <Link to={`/register?redirect=${redirectPath}`} className='member-btn'>
            הרשמה
          </Link>
        </p>
      </Form>
    </Wrapper>
  );
};

export default Login;
